import { useZoomMeetingContext } from '../ZoomMeetingContext/hooks';

export default function useRemoteAttendanceMarkedDialog() {
  const { container } = useZoomMeetingContext();
  return { container };
}
